import React, { useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSessionId, ThemeContext, useAuthProvider, leadAdapter, pdfDataAdapter, Loader, signupWithCodeAdapter, loginWithCodeAdapter } from "@cloudpremise/portal_core";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import DashboardLayout from "@cloudpremise/portal_core/src/themes/mui/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar";
import MDInput from "@cloudpremise/portal_core/src/themes/mui/components/MDInput";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";
import PdfViewer from "@cloudpremise/portal_core/src/themes/mui/components/PdfViewer";
import Banner from "../components/Banner";
import Card from "@mui/material/Card";
import MDTypography from "@cloudpremise/portal_core/src/themes/mui/components/MDTypography";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import { useIsAuthenticated } from '@azure/msal-react';
import { useMsal } from "@azure/msal-react";
import Config from "../Config";
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

import "../styles/landing.scss";

const cdnUrl = Config.getCdnUrl();
const bgImage = cdnUrl + "/assets/img/lead2.jpg";

declare const window: Window & typeof globalThis & {
    inlineApexAdaptor: any,
    pdfjsLib: any,
    PDFViewerApplication: any,
    getViewerConfiguration: any,
    onRegistrationFormComplete: any,
    verifyEmailRegistrationAF: any,
    onLoginFormComplete: any,
    verifyEmailLoginAF: any
}

const Landing = (props) => {
    const [ authorized, authType ] = useAuthProvider();
    const [state, setState] = React.useState({
        firstName: "",
        lastName: "",
        email: "",
        company: "",
        isSuccess: false,
        loading: false,
        errorMessage: null,
        pdfModal: false,
        pdfData: null,
        verifyCode: false,
        userId: "",
        code: "",
        identifier: "",
        login: false
    });
    const navigate = useNavigate();
    React.useEffect(() => {
        if(authorized){
            return navigate("/home"+window.location.search, { replace: true });
        }
    });
    function handleChange(e, name){
        setState({
            ...state,
            [name]: e.target.value,
        });
    }
    function onSubmit(e, signup = false){
        e.preventDefault();
        const { firstName, lastName, email, company, identifier, verifyCode, code, login, userId } = state;
        if(verifyCode){
            let completeFunc = null;
            if(login){
                if(typeof(window.onLoginFormComplete) === "function"){
                    completeFunc = window.onLoginFormComplete;
                }
                window.onLoginFormComplete = function(request, event, data){
                    setState({
                        ...state,
                        loading: false,
                        errorMessage: 'Verification code is not valid!'
                    });
    
                    if(completeFunc !== null){
                        window.onLoginFormComplete = completeFunc;
                    }
                }
                window.verifyEmailLoginAF(userId, identifier, code);
            }else{
                if(typeof(window.onRegistrationFormComplete) === "function"){
                    completeFunc = window.onRegistrationFormComplete;
                }
                window.onRegistrationFormComplete = function(request, event, data){
                    console.log("request", request);
                    console.log("event", event);
                    console.log("data", data);
                    setState({
                        ...state,
                        loading: false,
                        errorMessage: 'Unable to complete signup!'
                    });
    
                    if(completeFunc !== null){
                        window.onRegistrationFormComplete = completeFunc;
                    }
                }
                window.verifyEmailRegistrationAF(identifier, code);
            }
            
        }else{
            if(login){
                if(email.length <= 0){
                    return;
                }
                loginWithCodeAdapter(email, (data) => {
                    if(typeof(data) === "object" && data.hasOwnProperty("isSuccess") && data.isSuccess){
                        setState({
                            ...state,
                            identifier: data.identifier,
                            userId: data.userId,
                            loading: false,
                            verifyCode: true
                        });
                    }else{
                        let message = 'Email is not valid!';
                        if(typeof(data) === "object" && data.hasOwnProperty("result")){
                            message = data.result;
                        }
                        setState({
                            ...state,
                            loading: false,
                            errorMessage: message
                        });
                        console.log("Login Failed");
                    }
                });
            }else{
                if(!isFormValid()){
                    return;
                }
                leadAdapter(firstName, lastName, email, company, (data) => {
                    if(typeof(data) === "object" && data.hasOwnProperty("isSuccess") && data.isSuccess){
                        if(signup){
                            signupWithCodeAdapter(email, (data) => {
                                if(typeof(data) === "object" && data.hasOwnProperty("isSuccess") && data.isSuccess){
                                    setState({
                                        ...state,
                                        identifier: data.identifier,
                                        loading: false,
                                        verifyCode: true
                                    });
                                }else{
                                    let message = 'User already exists.';
                                    if(typeof(data) === "object" && data.hasOwnProperty("result")){
                                        message = data.result;
                                    }
                                    setState({
                                        ...state,
                                        loading: false,
                                        errorMessage: message
                                    });
                                    console.log("Signup Failed");
                                }
                            });
                        }else{
                            setState({
                                ...state,
                                loading: false,
                                isSuccess: true,
                                firstName: "",
                                lastName: "",
                                email: "",
                                company: ""
                            });
                        }
                    }else{
                        let message = 'Unable to create lead.';
                        if(typeof(data) === "object" && data.hasOwnProperty("result")){
                            message = data.result;
                        }
                        setState({
                            ...state,
                            loading: false,
                            errorMessage: message
                        });
                    }
                });
            }
            
        }
        
        setState({
            ...state,
            loading: true,
            errorMessage: null
        });
    }
    function onLoginLink(e, status = true){
        e.preventDefault();
        setState({
            ...state,
            errorMessage: null,
            verifyCode: false,
            login: status,
        });
    }
    if(authorized){
        return null;
    }
    function isFormValid(){
        const { email } = state;
        if(email.length > 0){
            return true;
        }
        return false;
    }
    if(authorized){
        return null;
    }
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox>
                <Banner
                    image={bgImage}
                    content={
                        (
                            <Container className="text-container">
                                <Grid container justifyContent="center" alignItems="center">
                                    <Grid item xs={12} sm={12} md={6} lg={8} position="relative">
                                        <h1>Welcome to Olympus-Grid</h1>
                                        <h2>Elevate Your Cloud</h2>
                                        <p className="description">Welcome to the future of enterprise systems—Olympus-Grid. Designed for innovators, developers, and enterprises, our platform empowers you to create robust, secure, and highly performant solutions with unparalleled flexibility and minimal operational overhead.</p>
                                    </Grid>
                                    <Card item xs={12} sm={12} md={6} lg={4} position="relative" component={Grid} p={2} className="lead-signup-card">
                                        {
                                            state.isSuccess ?
                                                <MDTypography component="span" sx={{fontSize: "14px"}}>
                                                    We have received your information and you will hear from us soon!
                                                </MDTypography>
                                            :
                                            <>
                                                <MDBox mb={2}>
                                                    <h3>
                                                        {
                                                            state.login ?
                                                                "Login with Code"
                                                            :
                                                                "Join Us. Start Your Journey."
                                                        }
                                                    </h3>
                                                </MDBox>
                                                {
                                                    state.login && !state.verifyCode ?
                                                        <MDBox mb={2}>
                                                            <MDInput
                                                                name="email"
                                                                type="email"
                                                                label="Email"
                                                                onChange={(event) => handleChange(event, "email")}
                                                                value={state.email}
                                                                sx={{width: "100%"}}
                                                                required
                                                            />
                                                        </MDBox>
                                                    :
                                                        state.verifyCode ?
                                                            <MDBox mb={2}>
                                                                <MDInput
                                                                    name="code"
                                                                    type="text"
                                                                    label="Code"
                                                                    fullWidth
                                                                    value={state.code}
                                                                    onChange={(e) => handleChange(e, "code")}
                                                                />
                                                            </MDBox>
                                                        :
                                                        <>
                                                            <MDBox mb={2}>
                                                                <MDInput
                                                                    name="firstName"
                                                                    type="text"
                                                                    label="First Name"
                                                                    onChange={(event) => handleChange(event, "firstName")}
                                                                    value={state.firstName}
                                                                    sx={{width: "100%"}}
                                                                    required
                                                                />
                                                            </MDBox>
                                                            <MDBox mb={2}>
                                                                <MDInput
                                                                    name="lastName"
                                                                    type="text"
                                                                    label="Last Name"
                                                                    onChange={(event) => handleChange(event, "lastName")}
                                                                    value={state.lastName}
                                                                    sx={{width: "100%"}}
                                                                    required
                                                                />
                                                            </MDBox>
                                                            <MDBox mb={2}>
                                                                <MDInput
                                                                    name="email"
                                                                    type="email"
                                                                    label="Email"
                                                                    onChange={(event) => handleChange(event, "email")}
                                                                    value={state.email}
                                                                    sx={{width: "100%"}}
                                                                    required
                                                                />
                                                            </MDBox>
                                                            <MDBox mb={2}>
                                                                <MDInput
                                                                    name="company"
                                                                    type="text"
                                                                    label="Company"
                                                                    onChange={(event) => handleChange(event, "company")}
                                                                    value={state.company}
                                                                    sx={{width: "100%"}}
                                                                />
                                                            </MDBox>
                                                        </>
                                                }
                                                {
                                                    state.errorMessage !== null ?
                                                        <Stack mb={2}>
                                                            <Alert severity="error">{state.errorMessage}</Alert>
                                                        </Stack>
                                                    :
                                                        null
                                                }
                                                {
                                                    state.verifyCode ?
                                                        <MDBox mb={2}>
                                                            <MDButton variant="gradient" color="info" onClick={(e) => onSubmit(e)}>
                                                                {
                                                                    state.loading ?
                                                                        <Loader color="white" size={20} />
                                                                    :
                                                                        "Verify Account"
                                                                }
                                                            </MDButton>
                                                        </MDBox>
                                                    :
                                                        state.login ?
                                                            <MDBox mb={2}>
                                                                <MDButton variant="gradient" color="info" onClick={(e) => onSubmit(e, false)}>
                                                                    {
                                                                        state.loading ?
                                                                            <Loader color="white" size={20} />
                                                                        :
                                                                        "Login with Code"
                                                                    }
                                                                </MDButton>
                                                            </MDBox>
                                                        :
                                                            <MDBox mb={2}>
                                                                <p>By creating an account, you gain access to:</p>
                                                                <p><strong>A Unified Platform:</strong> Build and deploy enterprise-grade applications seamlessly.</p>
                                                                <p><strong>Developer-Centric Tools:</strong> Leverage the Forge Plugin Manager, Hermes API Manager, and ChronosBPM for your projects.</p>
                                                                <p><strong>A Visionary Ecosystem:</strong> Be part of a platform that invests in innovation and gives back to the world.</p>
                                                                <p><strong>Sign up now to unlock your potential with Olympus-Grid.</strong></p>
                                                                <MDButton variant="gradient" color="info" onClick={(e) => onSubmit(e, true)}>
                                                                    {
                                                                        state.loading ?
                                                                            <Loader color="info" size={20} />
                                                                        :
                                                                        "Create Account"
                                                                    }
                                                                </MDButton>
                                                                <span style={{fontSize: "14px", marginRight: "8px", marginLeft: "8px"}}>or</span>
                                                                <Link to={"/auth"+window.location.search} style={{fontSize: "15px"}}>Other Options</Link>
                                                            </MDBox>
                                                }
                                                {
                                                    state.login ?
                                                        <MDBox mb={2}>
                                                            <MDTypography component="span" sx={{fontSize: "14px"}}>
                                                                Not registered? <Link to={"/"+window.location.search} onClick={(e) => onLoginLink(e, false)}>Register here</Link>
                                                            </MDTypography>
                                                        </MDBox>
                                                    :
                                                        <MDBox mb={2}>
                                                            <MDTypography component="span" sx={{fontSize: "14px"}}>
                                                                Already registered? <Link to={"/"+window.location.search} onClick={(e) => onLoginLink(e)}>Login here</Link>
                                                            </MDTypography>
                                                        </MDBox>
                                                }
                                            </>
                                        }
                                        </Card>
                                </Grid>
                            </Container>
                        )
                    }
                />
            </MDBox>
        </DashboardLayout>
    )
}

export default Landing;